@Config('ib-subscription-models-routing-module')
class RouterConfig {

    constructor (private $routeProvider: any, private SubscriptionModelsRouterConstants: SubscriptionModelsRouterConstants) {

    }

    active = ():void => {
        this.$routeProvider.
            when(this.SubscriptionModelsRouterConstants.PAGES_URL.SUBSCRIPTIONMODELS_CONFIGURATION, {
                template: '<ib-subscription-models-configuration></ib-subscription-models-configuration>',
                reloadOnSearch: false
            }).when('/PLPURC', {
                templateUrl: this.SubscriptionModelsRouterConstants.TEMPLATES_ROUTE + this.SubscriptionModelsRouterConstants.PAYMENT_ROUTE,
                controller: 'PmtPageController',
                controllerAs: 'paymentCtrl',
                reloadOnSearch: false
            }).when(this.SubscriptionModelsRouterConstants.PAGES_URL.SUBSCRIPTIONMODELS_PAYMENTS, {
                template: '<ib-subscription-models-payments></ib-subscription-models-payments>',
                reloadOnSearch: false
            }).when(this.SubscriptionModelsRouterConstants.PAGES_URL.SUBSCRIPTIONMODELS_CONFIRMATION, {
                template: '<ib-subscription-models-new-confirmation></ib-subscription-models-new-confirmation>',
                reloadOnSearch: false
            }).when('/PLBKCF', {
                templateUrl: this.SubscriptionModelsRouterConstants.TEMPLATES_ROUTE + this.SubscriptionModelsRouterConstants.CONFIRMATION_ROUTE,
                controller: 'SubscriptionModelsConfirmationController',
                controllerAs: 'confirmationCtrl',
                reloadOnSearch: false
            }).when(this.SubscriptionModelsRouterConstants.PAGES_URL.SUBSCRIPTIONMODELS_ERROR, {
                template: '<ib-subscription-models-generic-error></ib-subscription-models-generic-error>',
                reloadOnSearch: false
            }).otherwise({
                redirectTo: this.SubscriptionModelsRouterConstants.PAGES_URL.SUBSCRIPTIONMODELS_CONFIGURATION
            });
    };
    $onInit = this.active();
}
RouterConfig.$inject = ['$routeProvider', 'SubscriptionModelsRouterConstants'];

